import React from 'react';
import styled from '@emotion/styled';
import { Spinner } from '../../Spinner/Spinner';

const SpinnerOverlay = styled('div')({
  position: 'absolute',
  width: '100%',
  height: '100%',
  background: 'rgba(255, 255, 255, 0.6)',
  top: 0,
  left: 0,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

export const ChartSpinnerOverlay: React.FC = () => {
  return (
    <SpinnerOverlay>
      <Spinner />
    </SpinnerOverlay>
  );
};
